import React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  SkipToContentLink,
  SkipToContentTarget,
} from 'components/polaris/react/skip-to-content';
import {Header, Footer, ErrorBoundary, RouteTracker} from './components';
import {Switch, Route} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {ScrollToTop} from '../components';
import ProfileListing from './sections/profile/profile-listing';
import ProfileIndex from './sections/profile/profile-index';
import Home from './sections/home';
import CreateJob from './sections/create-job';
import NotFound from './sections/not-found';
import CategoryIndex from './sections/category-index';
import SectionFactory from './sections/SectionFactory';
import SavedExperts from './sections/saved-experts';
import railsData from 'utilities/rails-data';
import i18nArgs from './locales';

import styles from './Experts.scss';
import {ServicesMarketplacePublicProvider} from 'utilities/graphql';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

function Experts({i18n}: CombinedProps) {
  return (
    <ErrorBoundary>
      <ServicesMarketplacePublicProvider>
        {railsData('env') === 'production' && <RouteTracker />}
        <ScrollToTop>
          <div className={styles.ExpertsMarketplace}>
            <Helmet>
              <title>{i18n.translate('Global.Meta.appTitle')}</title>
              <meta
                name="description"
                content={i18n.translate('Global.Meta.appDescription')}
              />
            </Helmet>
            <SkipToContentLink />
            <Header />
            <SkipToContentTarget />
            <main className={styles.Main}>
              <ErrorBoundary>
                <Switch>
                  <Route exact path="/create-a-job" component={CreateJob} />
                  <Route exact path="/saved-experts" component={SavedExperts} />
                  <Route
                    exact
                    path="/services/:serviceSlug1/:serviceSlug2?/:serviceSlug3?"
                    component={SectionFactory}
                  />
                  <Route exact path="/services" component={CategoryIndex} />
                  <Route
                    exact
                    path="/:expertSlug/:serviceSlug"
                    component={ProfileListing}
                  />
                  <Route exact path="/:expertSlug" component={ProfileIndex} />
                  <Route exact path="/" component={Home} />
                  <Route component={NotFound} />
                </Switch>
              </ErrorBoundary>
            </main>
            <Footer />
          </div>
        </ScrollToTop>
      </ServicesMarketplacePublicProvider>
    </ErrorBoundary>
  );
}

export default withI18n(i18nArgs)(Experts);
